import apiClient from './apiClient';

// Generic "booking emails -> reservations" import. Admin CRUD + review
// queue live under /v1/email-bookings/* (same hotel-admin JWT auth as every
// other /v1/settings/* surface) — the inbound webhook itself is public and
// lives outside this service (backend_appdesko.com/email_bookings).
const emailBookingsService = {
  listSources: () => apiClient.get('/v1/email-bookings/sources'),
  createSource: (data) => apiClient.post('/v1/email-bookings/sources', data),
  updateSource: (id, data) => apiClient.put(`/v1/email-bookings/sources/${id}`, data),
  deleteSource: (id) => apiClient.del(`/v1/email-bookings/sources/${id}`),
  testParse: (id, data) => apiClient.post(`/v1/email-bookings/sources/${id}/test-parse`, data),

  listMessages: (params) => apiClient.get('/v1/email-bookings/messages', params),
  getMessage: (id) => apiClient.get(`/v1/email-bookings/messages/${id}`),
  importMessage: (id, overrides) => apiClient.post(`/v1/email-bookings/messages/${id}/import`, overrides || {}),
  ignoreMessage: (id) => apiClient.post(`/v1/email-bookings/messages/${id}/ignore`, {}),
};

export default emailBookingsService;
